import { Image, Modal } from "antd";
import { useState } from "react";
import { FaAward } from "react-icons/fa";
import SalonStatus from "../common/SalonStatus";
import ContactsSalon from "./ContactsSalon";
import InfoSalon from "./InfoSalon";
import PricingPlanModal from "./PricingPlanModal";

type Props = {
  data: any;
};

const SalonDetails = ({ data }: Props) => {
  const [modalPrice, setModalPrice] = useState(false);
  const [modalPriceUpdate, setModalPriceUpdate] = useState(false);

  const closeModal = () => {
    setModalPrice(false);
    setModalPriceUpdate(false);
  };
  const openModal = (type: any) => {
    setModalPrice(true);
  };
  const salonLogo = data?.settings?.find(
    (item: any) => item?.key === "brand_logo"
  )?.media?.[0]?.media_url;
  const salonBrandBg = data?.settings?.find(
    (item: any) => item?.key === "brand_gallery"
  )?.media?.[0]?.media_url;
  const salon_brand_color_theme =
    data?.settings
      ?.find((item: any) => item?.key === "brand_color_theme")
      ?.value?.background_color?.replace("#", "") || "00086d";
  console.log(data);

  return (
    <>
      <Modal
        width={modalPriceUpdate ? "70%" : "40%"}
        open={modalPrice}
        onCancel={closeModal}
        className="max-md:min-w-[95%] max-lg:min-w-[80%]"
        footer={null}
        destroyOnClose
      >
        <PricingPlanModal
          modalPriceUpdate={modalPriceUpdate}
          data={data}
          setModalPriceUpdate={setModalPriceUpdate}
        />
      </Modal>
      <div className="bg-white  flex flex-col items-center justify-center gap-4 px-4 py-[18px] rounded-xl w-full h-full">
        <div className="w-full relative h-fit mb-[8%]">
          <Image
            preview={false}
            width="100%"
            className="w-full object-cover max-h-[130px] rounded-[10px]"
            src={
              salonBrandBg
                ? salonBrandBg
                : `https://placehold.co/600x300/${salon_brand_color_theme}/${salon_brand_color_theme}?text=${data?.name}`
            }
          />

          <div
            onClick={openModal}
            className="bg-white flex cursor-pointer items-center gap-1 text-[#75757E] px-3 py-2 absolute top-1 left-1 text-color-primary rounded-lg text-sm"
          >
            <FaAward className="flex items-center text-color-primary" />
            <span>Pricing plan</span>
            <span className="font-semibold">
              {data?.subscriptionPlan?.name}
            </span>
          </div>
          <SalonStatus status={data?.status} style={""} />
          <div className="max-h-[100px] absolute right-1/2 top-1/3 translate-y-1/3 translate-x-1/2">
            <Image
              preview={false}
              width={100}
              height={100}
              className="object-cover border-4 border-white border-solid rounded-full"
              src={salonLogo ? salonLogo : ""}
            />
          </div>
        </div>
        <InfoSalon data={data} />
        <ContactsSalon data={data} />
      </div>
    </>
  );
};

export default SalonDetails;
